import React, { useState } from "react";

import { string, func, bool, object, any } from "prop-types";

import { Link } from "react-router-dom";
import {
  Button,
  TextFieldGroup,
  SelectListGroup,
  TextAreaGroup,
} from "../../../../common";
import history from "../../../../history";

import { monthOptions, yearOptions } from "../../../../helpers";
import * as style from "../styles.module.scss";
import Checkbox from "../../../../common/Checkbox/index";

const WorkHistoryForm = ({
  title,
  companyName,
  fromMonth,
  toMonth,
  fromYear,
  toYear,
  currentlyWorkHere,
  description,
  isValid,
  validation,
  onChange,
  onSave,
  onboardStateUpdate,
  onboardState,
}) => {
  const [touchedFields, setTouchedFields] = useState({});
  return (
    <div className={`${style.workHistoryForm__container}`}>
      <div className="form-row">
        <div className="col-12">
          <div className="form-group">
            <label htmlFor="title">Job title*</label>
            <TextFieldGroup
              classes="register_field"
              value={title}
              onChange={(e) => {
                onChange("title", e.target.value);
              }}
              validationMessages={validation.title}
              onlyShowValidationAfterChange
              dontDisplayErrorMessage
            />
          </div>
          <div className="form-group">
            <label htmlFor="companyName">Company*</label>
            <TextFieldGroup
              classes="register_field"
              value={companyName}
              onChange={(e) => {
                onChange("companyName", e.target.value);
              }}
              validationMessages={validation.companyName}
              onlyShowValidationAfterChange
              dontDisplayErrorMessage
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12 ">
          <div className="form-group">
            <Checkbox
              label="I currently work here"
              value={currentlyWorkHere}
              onClick={(e) => onChange("currentlyWorkHere", e.target.checked)}
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-lg-12 col-xl-12 form-group">
              <label className="mb-hf">From*</label>
              <div className="d-flex">
                <SelectListGroup
                  id="workHistoryFromMonth"
                  classes="register_field register_field-dropdown mr-1"
                  options={monthOptions}
                  value={fromMonth}
                  isError={
                    touchedFields.fromMonth &&
                    validation.fromMonth !== undefined
                  }
                  onChange={(e) => {
                    onChange("fromMonth", e.target.value);
                  }}
                  onBlur={() => {
                    setTouchedFields((prevTouchedFields) => ({
                      ...prevTouchedFields,
                      fromMonth: true,
                    }));
                  }}
                />
                <SelectListGroup
                  id="workHistoryFromYear"
                  classes="register_field register_field-dropdown"
                  options={yearOptions}
                  value={fromYear}
                  isError={
                    touchedFields.fromYear && validation.fromYear !== undefined
                  }
                  onChange={(e) => {
                    onChange("fromYear", e.target.value);
                  }}
                  onBlur={() => {
                    setTouchedFields((prevTouchedFields) => ({
                      ...prevTouchedFields,
                      fromYear: true,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            {!currentlyWorkHere && (
              <div className="col-md-12 col-lg-12 col-xl-12 form-group">
                <label className="mb-hf">To*</label>
                <div className="d-flex">
                  <SelectListGroup
                    classes="register_field register_field-dropdown mr-1"
                    options={monthOptions}
                    value={toMonth}
                    isError={
                      touchedFields.toMonth && validation.toMonth !== undefined
                    }
                    onChange={(e) => {
                      onChange("toMonth", e.target.value);
                    }}
                    onBlur={() => {
                      setTouchedFields((prevTouchedFields) => ({
                        ...prevTouchedFields,
                        toMonth: true,
                      }));
                    }}
                  />
                  <SelectListGroup
                    classes="register_field register_field-dropdown"
                    options={yearOptions}
                    value={toYear}
                    isError={
                      touchedFields.toYear && validation.toYear !== undefined
                    }
                    onChange={(e) => {
                      onChange("toYear", e.target.value);
                    }}
                    onBlur={() => {
                      setTouchedFields((prevTouchedFields) => ({
                        ...prevTouchedFields,
                        toYear: true,
                      }));
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <TextAreaGroup
              classes={`register_field ${style.workHistoryForm__description}`}
              value={description}
              rows={7}
              onChange={(e) => {
                onChange("description", e.target.value);
              }}
              validationMessages={validation.description}
              onlyShowValidationAfterChange
              dontDisplayErrorMessage
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <Button
            disabled={!isValid}
            classes="btn btn-outline-info text-dark"
            onClick={() => {
              onSave();
              onboardStateUpdate({ ...onboardState, cv: false });
            }}
          >
            Add another position
          </Button>
        </div>
      </div>
      <div className="form-row mt-2 mb-2">
        <div className="col-12">
          <Link to="/onboard/cv-upload" style={{ textDecoration: "underline" }}>
            OR upload your CV
          </Link>
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <Link to="/onboard/work-type">
            <Button classes="btn btn-outline-info text-dark mb-2">
              Skip - I&apos;ll do this later&nbsp;
            </Button>
          </Link>
        </div>
      </div>
      <div
        className={`mt-lg-auto my-2 mb-lg-0 ${style.cvInfo_button__container}`}
      >
        <Link
          to="/onboard/address"
          className="btn-plain d-block text-info text-center"
        >
          <button className="btn btn-outline-info text-dark mr-1">Back</button>
        </Link>

        <Button
          id="btnSubmitWorkHistory"
          classes="btn btn-primary btn-block"
          onClick={() => {
            onSave();
            onboardStateUpdate({ ...onboardState, cv: false });
            history.push("/onboard/work-type");
          }}
          disabled={!isValid}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

WorkHistoryForm.propTypes = {
  title: string.isRequired,
  companyName: string.isRequired,
  fromMonth: string.isRequired,
  toMonth: string.isRequired,
  fromYear: string.isRequired,
  toYear: string.isRequired,
  currentlyWorkHere: bool.isRequired,
  description: string.isRequired,
  isValid: bool.isRequired,
  validation: object.isRequired,
  onChange: func.isRequired,
  buttonText: string.isRequired,
  onSave: func.isRequired,
  toggleForm: func,
  showForm: bool,
  onboardStateUpdate: func,
  onboardState: any,
};

export default WorkHistoryForm;
